// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-UserAnalytics-UserAnalytics-module__container--256Pe","appSelect":"src-components-UserAnalytics-UserAnalytics-module__appSelect--2NpHX"};